import { WalletError } from "@solana/wallet-adapter-base";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import {
  getLedgerWallet,
  getMathWallet,
  getPhantomWallet,
  getSolletWallet,
  getSolongWallet,
} from "@solana/wallet-adapter-wallets";
import { useSnackbar } from "notistack";
import React, { useCallback, useMemo } from "react";
import "./App.css";
import { backendApi } from "./assets/constants";
import LandingPage from "./screens/LandingPage/LandingPage";

const WalletWrapper = () => {
  const endpoint = useMemo(() => backendApi, []);
  const wallets = useMemo(
    () => [
      getSolletWallet(),
      getPhantomWallet(),
      getLedgerWallet(),
      getSolongWallet(),
      getMathWallet(),
    ],
    []
  );

  const { enqueueSnackbar } = useSnackbar();
  const onError = useCallback(
    (error: WalletError) => {
      enqueueSnackbar(
        error.message ? `${error.name}: ${error.message}` : error.name,
        { variant: "error" }
      );
      console.error(error);
    },
    [enqueueSnackbar]
  );
  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect={false} onError={onError}>
        <LandingPage />
      </WalletProvider>
    </ConnectionProvider>
  );
};

export default WalletWrapper;
